export interface FeatureFlag {
  id: FeatureFlagId;
  description: string;
  organizations: string[];
  enabled: boolean;
  enabledForEveryone: boolean;
  isEnabledForCurrentOrganization: boolean;
}

export enum FeatureFlagId {
  FeedbackAnalysis = 1,
  NewCampaignMemberCreationFlow = 2,
  NewOrdersPage = 3
}
